import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import IndexPageMainContainer from '../../components/index/IndexPageMainContainer';

const IndexPage = React.memo(() => {

  return (
    <>
      {/* Page */}
      <div className='grid min-h-screen h-screen max-h-screen overflow-hidden bg-colour2 font-poppins'>
        <div className='grid grid-rows-reg'>
          {/* Navigation */}
          <Navbar />

          {/* Main page content */}
          <IndexPageMainContainer />
        </div>
      </div>
    </>
  );
});

export default IndexPage;
